import queryString from 'query-string';
import { IUrlInterceptor, IUrlInterceptorParams } from './urlInterceptorTypes';
import { abPromise } from '@/store/useAbStore';

export async function execUrlInterceptor(originUrl: string, interceptors: IUrlInterceptor[]) {
    console.log(`[OpenUrl] interceptor before build url: ${originUrl}`);
    // 初始化参数
    const { url: _url, query = {} } = queryString.parseUrl(originUrl);
    let redirectUrl = {};
    if (query.redirectUrl) {
        redirectUrl = queryString.parse(query.redirectUrl as string);
    }
    const abRes = await abPromise;
    const initParams: IUrlInterceptorParams = {
        url: _url,
        params: { ...query, ...redirectUrl },
        redirectUrl,
        abRes,
    };
    // 执行url拦截器
    const startTime = Date.now();
    console.log(`[OpenUrl] interceptor build url with initParams: `, initParams);
    const res = (await interceptors.reduce<IUrlInterceptorParams>(async (pre: IUrlInterceptorParams, curr: IUrlInterceptor) => {
        return await curr(pre);
    }, initParams)) as unknown as IUrlInterceptorParams;
    console.log(`[OpenUrl] interceptor build url cost time: ${Date.now() - startTime} , res: `, res);

    // 返回结果
    const resUrl = queryString.stringifyUrl(
        {
            url: res.url,
            query: Object.assign(
                {},
                // 参数
                res.params,
                // 判断是否需要追加krn redirectUrl
                { redirectUrl: Object.keys(res.redirectUrl || {}).length ? queryString.stringify(res.redirectUrl) : null }
            ),
        },
        { sort: false, skipNull: true }
    );
    console.log(`[OpenUrl] interceptor after build url: ${resUrl}`);
    return resUrl;
}
